<template>
  <v-app>
    <v-navigation-drawer
      app
      v-model="drawer"
      color="#424242"
      dark
      disable-resize-watcher
    >
      <v-list>
        <!--create list of items, and link them to appropriate view-->
        <template v-for="(el, index) in elements">
          <v-list-tile :key="index" :to="el.title">
            <v-list-tile-content>
              {{ el.title }}
            </v-list-tile-content>
          </v-list-tile>

          <v-divider :key="`divider-${index}`"></v-divider>
        </template>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar app color="#424242" dense clipped-right dark>
      <v-app-bar-nav-icon class="hidden-md-and-up" @click="drawer = !drawer">
      </v-app-bar-nav-icon>

      <!-- make toolbar title a link to return to home page -->
      <router-link to="/">
        <v-toolbar-title>
          <v-btn text class="title hidden-sm-and-down subtitle-1 mr-1">{{
            appTitle
          }}</v-btn>
        </v-toolbar-title>
      </router-link>

      <hr width="1" size="40" />
      <v-btn text class="hidden-sm-and-down mr-1" to="/resume">Resume</v-btn>
      <v-btn text class="hidden-sm-and-down mr-1" to="/projects"
        >Projects</v-btn
      >
      <v-btn text class="hidden-sm-and-down mr-1" to="/contact">Contact</v-btn>
    </v-app-bar>

    <v-content class="home-page pt-12 mt-12">
      <v-row justify-start xs12 sm8 md4>
        <v-col cols="4" xs12 sm10 md8 class="d-flex flex-column ml-9">
          <v-avatar id="avatar" color="#424242" size="200" class="ml-12">
            <img src="./assets/me.jpg" />
          </v-avatar>

          <v-col class="d-flex flex-grow-0 flex-shrink-0 justify-start mt-8">
            <v-text class="font-weight-black text-uppercase">
              <h2>Damon Bonner</h2>
              <br />

              <v-text class="d-flex justify start subtitle-1"
                >damonjbonner@gmail.com</v-text
              >
            </v-text>
          </v-col>

          <v-col class="d-flex flex-grow-0 flex-shrink-0 justify-start mt-8">
            <v-text>
              <v-divider class="mt-2" role="presentation" light></v-divider>
              <p
                class="text-justify font-weight-black subtitle-1 text-uppercase mt-9"
              >
                About
              </p>
              <br />
              <p class="text-justify body-1">
                I am currently studying computer science at CSU Stanislaus. I
                spent over ten years as an automotive technician before deciding
                to pursue a career that is more challenging, purposeful, and
                rewarding. I received my A.S. from Modesto Junior College. I
                enjoy being challenged and engaging in with projects that
                require me to work outside of my comfort and knowledge set, as
                continuing to learn new development techniques are vital to any
                developer’s success.
              </p>
            </v-text>
          </v-col>

          <v-btn
            right
            outlined
            small
            width="100px"
            class="mt-4 mb-2"
            to="/resume"
            >More</v-btn
          >
          <v-divider class="mt-8" role="presentation" light></v-divider>

          <v-flex class="d-flex justify-start mt-8">
            <v-btn icon href="https://github.com/rizingson" target="_blank">
              <v-icon class="pa-2">mdi-github</v-icon>
            </v-btn>

            <v-btn
              icon
              href="https://www.facebook.com/damon.bonner.33"
              target="_blank"
            >
              <v-icon class="pa-2">mdi-facebook</v-icon>
            </v-btn>

            <v-btn
              icon
              href="https://www.instagram.com/rizing_son/?hl=en"
              target="_blank"
            >
              <v-icon class="pa-2">mdi-instagram</v-icon>
            </v-btn>

            <v-btn
              icon
              href="https://www.linkedin.com/in/damon-bonner-9a5579178/"
              target="_blank"
            >
              <v-icon class="pa-2">mdi-linkedin</v-icon>
            </v-btn>

            <v-btn icon href="mailto: damonjbonner@gmail.com">
              <v-icon class="pa-2">mdi-email</v-icon>
            </v-btn>
          </v-flex>
        </v-col>

        <!-- <v-container class="home-page pt-12 mt-12">-->
        <v-row justify-center xs12 sm10 md8>
          <v-col cols="10" class="d-block ml-9">
            <router-view />
          </v-col>
        </v-row>
        <!--</v-container>-->
      </v-row>
      <v-card>
        <v-footer dark class="font-weight-medium" color="#424242">
          <v-col class="text-center" cols="12">
            <strong>rizingson</strong>&nbsp; &copy;{{
              new Date().getFullYear()
            }}
          </v-col>
        </v-footer>
      </v-card>
    </v-content>
  </v-app>
</template>

<script>
export default {
  name: "App",
  data() {
    return {
      //title on tool bar, nav drawer closed by default, array for nav menu elements,
      //facebook icon/link
      appTitle: "Damon Bonner",
      drawer: false,
      elements: [
        { title: "Resume" },
        { title: "Projects" },
        { title: "Contact" }
      ]
    };
  }
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  background-color: whitesmoke;
  padding-bottom: 0;
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}

.home-page {
  background-color: whitesmoke;
}

a {
  color: white;
  text-decoration: none;
}

h2 {
  font-size: 2em;
  font-weight: 900;
}
</style>
